export const recharges = {
	title: "Recargas",
	activeTab: "recharges",
	export: "Exportar Excel",
	transactionedValue: "Valor Transaccionado",
	value: "Valor Bruto Emitido",
	netValue: "Valor Neto Emitido",
	periodFilter: "Filtrar por período",
	eventsFilter: "Filtrar por eventos",
	filterIssuedLabel: "Filtrar por estado",
	eventsSelected: "eventos seleccionados",
	eventsFilterPlaceholder: "Seleccione el(los) evento(s)",
	descriptionForeign:
		"Este informe muestra todas las recargas y muestra información de la Factura Fiscal asociada a ellas, si existen. Permite filtrar por período, eventos y estado.",
	columns: {
		totalValue: "Valor de la recarga",
		usedValue: "Valor consumido",
		date: "Fecha",
		eventName: "Evento",
		eventDate: "Fecha evento",
		cnpj: "CNPJ Emisor",
		cpf: "CPF Cliente",
		type: "Tipo",
		issuerNIF: "NIF Comerciante",
		recipientNIF: "NIF Cliente",
		invoiceSeries: "Serie factura",
		invoiceNumber: "N° factura",
		invoiceValue: "Valor factura",
		invoiceNetValue: "Valor neto de la factura",
		invoiceDate: "Fecha Emisión",
	},
};
